import { Component, inject } from '@angular/core';
import { WhatsappService } from '../../../core/services/whatsapp.service';

@Component({
  selector: 'app-whatsapp-fab',
  standalone: true,
  templateUrl: './whatsapp-fab.component.html',
})
export class WhatsappFabComponent {
  private whatsapp = inject(WhatsappService);
  link = this.whatsapp.registerLink();
}
